import React, { useEffect, useState, useCallback } from 'react'
import { Button, Paper, Typography } from '@material-ui/core'
import { Music } from 'lucide-react'

import QuickTable from '../QuickTable'
import AudioPlayer from '../AudioPlayer'
import NotificationSoundModal from '../NotificationSoundModal'
import api from '../../services/api'
import toastError from '../../errors/toastError'
import { toast } from 'react-toastify'
import { useStyles } from '../../pages/NotificationSounds/style'

const NotificationSoundsManager = () => {
  const classes = useStyles()
  const [sounds, setSounds] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)

  const fetchData = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await api.get('/notification-sounds')
      setSounds(data?.sounds || [])
    } catch (error) {
      toastError(error)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const handleRemove = async soundId => {
    try {
      await api.delete(`/notification-sounds/${soundId}`)
      toast.success('Áudio removido com sucesso.')
      fetchData()
    } catch (error) {
      toastError(error)
    }
  }

  const columns = [
    { field: 'name', headerName: 'Nome' },
    {
      field: 'url',
      headerName: 'Player',
      headerStyle: { width: '320px' },
      align: 'center'
    }
  ]

  const customCellRenderer = {
    url: row => (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <AudioPlayer audioUrl={row.url} variant="compact" />
      </div>
    )
  }

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Sons de notificação
      </Typography>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          flexWrap: 'wrap',
          marginBottom: 16
        }}
      >
        <Button
          variant="contained"
          color="primary"
          className={classes.buttonNewSound}
          onClick={() => setModalOpen(true)}
          startIcon={<Music size={20} />}
        >
          Novo Som de Notificação
        </Button>
      </div>
      <Paper className={classes.mainPaper} variant="outlined">
        <QuickTable
          data={sounds}
          columns={columns}
          loading={loading}
          actions={['delete']}
          onDelete={item => handleRemove(item.id)}
          customCellRenderer={customCellRenderer}
          emptyMessage="Nenhum som de notificação cadastrado."
          skeletonRows={5}
        />
      </Paper>
      <NotificationSoundModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSave={fetchData}
      />
    </>
  )
}

export default NotificationSoundsManager
